exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea{resize:vertical;width:100%}.title{font-weight:700}.datab{position:relative;padding:10px}.datab .loader{position:absolute;width:100%;height:100%;background-color:hsla(0,0%,39%,.3);top:0;left:0}.datab .loader .spinner{position:absolute;left:50%;top:50%;width:100px;margin-left:-50px;margin-top:-30px}.assignment{padding:15px;position:relative;background-color:#fff}.assignment h1{margin-top:5px}.points{width:50px;height:50px;background-color:#fff;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);border-radius:50%;position:absolute;bottom:-26px;right:16px;z-index:101}.assignment.level-Gold{border-bottom:2px solid gold}.assignment.level-Gold .points{background-color:gold}.assignment.level-Bronze{border-bottom:2px solid #cd7f32}.assignment.level-Bronze .points{background-color:#cd7f32}.assignment.level-Silver{border-bottom:2px solid silver}.assignment.level-Silver .points{background-color:silver}.assignment .points.complete{background-color:#5cb85c!important}.points span{color:#fff;font-weight:700;display:block;width:100%;text-align:center;line-height:50px;font-size:16px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/extern/databases/datab.component.css
// module id = 504
// module chunks = 1